import React, { useEffect, useState } from "react";
import "./scss/App.scss";
import { useQuery } from "./hooks/useQuery";
import { applyActionCode } from "firebase/auth";
import { auth } from "./firebase/firebase";

// Assets
import logo from "./assets/HOOBS_Logo.svg";

const EmailVerification: React.FC = () => {
    // Hooks
    const query = useQuery();

    // States
    const [error, setError] = useState<string | null>(null);
    const [verifiedCode, setVerifiedCode] = useState(false);

    const oobCode = query.get("oobCode");

    const verifyCode = async () => {
        setError("");
        try {
            if (oobCode) {
                await applyActionCode(auth, oobCode);
                setVerifiedCode(true);
            } else {
                window.location.href = "https://hoobs.com";
            }
        } catch (e: any) {
            switch (e.code) {
                case "auth/expired-action-code":
                    console.error("The reset code has expired.");
                    setError("The reset code has expired");
                    break;

                case "auth/invalid-action-code":
                    console.error("The reset code is invalid.");
                    setError("The reset code is invalid");
                    break;

                case "auth/user-disabled":
                    console.error("The user associated with this code has been disabled.");
                    setError("The user associated with this code has been disabled");
                    break;

                case "auth/user-not-found":
                    console.error("No user found for the given reset code.");
                    setError("No user found for the given reset code");
                    break;

                case "auth/network-request-failed":
                    console.error("Network error. Please try again.");
                    setError("Network error. Please try again");
                    break;

                default:
                    console.error("An unexpected error occurred:", e.message);
                    setError("An unexpected error occured");
                    break;
            }
        }
    };

    useEffect(() => {
        verifyCode();
    }, [oobCode]);

    useEffect(() => {
        if (verifiedCode) {
            setTimeout(() => {
                window.location.href = "https://hoobs.com"; // Redirect to home page after 3 seconds
            }, 3000);
        }
    }, [verifiedCode]);

    return (
        <div className="container">
            <div className="content">
                <img src={logo} className="logo" />
                {verifiedCode && <b className="info__success">Email Verified</b>}
                {error && <p className="info__error">{error}</p>}
            </div>
        </div>
    );
};

export default EmailVerification;
